<template>
  <div class="position-relative">
    <!-- <TransactionDetailsModal
      v-if="details"
      :details="details"
      :moreDetails="false"
    /> -->
    <ejs-grid
      v-show="!showLoader"
      ref="dataGrid"
      :created="refreshGrid"
      :allowPaging="true"
      :allowSorting="true"
      :pageSettings="pageSettings"
      :toolbar="toolbar"
      :searchSettings="search"
      :allowExcelExport="true"
      :allowPdfExport="true"
      :toolbarClick="toolbarClick"
      :locale="usedLang"
      :dataSource="voucherHistory"
      :rowDataBound="rowDataBound"
    >
      <e-columns>
        <e-column width="40" field="index" headerText="#"></e-column>

        <e-column
          field="date"
          width="180"
          :headerText="$t('text.calendar.date')"
        ></e-column>

        <e-column
          field="validity"
          width="150"
          :headerText="$t('text.drivers.validity')"
        ></e-column>

        <e-column
          field="staff"
          width="200"
          :headerText="$t('text.bMasterLayout.staff')"
        ></e-column>
        <e-column
          field="ownerEmail"
          width="200"
          :headerText="$t('text.cards.ownerEmail')"
        ></e-column>

        <e-column
          field="amount"
          width="150"
          format="N"
          :headerText="$t('text.form.amount')"
        ></e-column>

        <e-column
          field="consumptionStatus"
          width="130"
          :headerText="$t('text.cDrystock.supplies.status')"
        ></e-column>

        <e-column
          field="pin"
          width="120"
          :headerText="$t('text.addCardVehicle.pin')"
        ></e-column>

        <e-column
          field="location"
          width="200"
          :headerText="$t('text.cards.location')"
        ></e-column>

        <e-column
          field="returnBalanceTo"
          width="200"
          :headerText="$t('text.cards.returnBalance')"
        ></e-column>

        <e-column
          field="transferred"
          width="120"
          :headerText="$t('text.voucher.transferred')"
        ></e-column>
        <e-column
          field="vehicle"
          width="250"
          :headerText="$t('text.cards.vehicle')"
        ></e-column>

        <e-column
          field="expiryDate"
          width="150"
          :headerText="$t('text.cards.expiryDate')"
        ></e-column>

        <!-- <e-column
          width="200"
          :headerText="$t('text.cBranchWallet.action')"
          :template="viewDetails"
        >
        </e-column> -->
      </e-columns>
    </ejs-grid>
    <TableLoader :showLoader="showLoader" />
  </div>
</template>

<script>
import Vue from "vue";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import TableLoader from "@/components/tableLoader/index";
import TransactionDetailsModal from "@/components/modals/Remis/TransactionDetailsModal.vue";

export default {
  name: "VoucherHistory",
  props: ["showLoader", "voucherHistory"],
  components: {
    TableLoader,
    TransactionDetailsModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  created() {
    this.$eventHub.$on("tranDetailsModal", (data) => {
      this.details = data;

      this.$modal.show("accountCompanySettlement");
    });
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      details: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      viewDetails: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `  <button @click="viewDetails" style="background-color:#290C53; padding:15px; border:none; color:white; border-radius:5px;"> {{ $t("text.cBranchWallet.viewMore") }}</button>  
         `,
            data() {
              return {
                data: {},
              };
            },

            methods: {
              viewDetails() {
                this.$eventHub.$emit("tranDetailsModal", this.data);
              },
            },
          }),
        };
      },
    };
  },

  methods: {
    //Utilities

    rowDataBound: function (args) {
      if (args.data["status"] === "Debit") {
        args.row.cells[4].style.color = "red";
      }
      if (args.data["status"] === "Credit") {
        args.row.cells[4].style.color = "green";
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
  },
};
</script>

<style>
</style>